import $ from "jquery";

const footerMenuTitle = $(".footer-menu-section .dropdown-toggle"),
  footerMenuWrapper = $(".footer-menu-section .dropdown-menu");

function pointerEventsSwitch() {
  if ($(window).width() > 1023) {
    footerMenuTitle.css("pointer-events", "none").removeAttr("aria-expanded").removeAttr("aria-haspopup");
  } else {
    footerMenuTitle.css("pointer-events", "all").attr("aria-expanded", "false").attr("aria-haspopup", "true");
  }
}
pointerEventsSwitch();

$(window).on("resize", function () {
  pointerEventsSwitch();
});

footerMenuTitle.on("click", function (e) {
  e.preventDefault();
  if (!$(this).siblings(".dropdown-menu").is(":visible")) {
    footerMenuTitle.removeClass("opened").attr("aria-expanded", "false");
    footerMenuWrapper.slideUp();
    $(this).addClass("opened").attr("aria-expanded", "true");
    $(this).siblings(".dropdown-menu").slideDown();
  } else {
    footerMenuTitle.removeClass("opened").attr("aria-expanded", "false");
    footerMenuWrapper.slideUp();
  }
});

footerMenuTitle.keydown(function(e) {
  if (e.keyCode == 13 || e.keyCode == 32) {
    $(this).click();
    e.preventDefault();
  }
});

